module.exports = __webpack_public_path__ + "static/img/adaptadorEsp01-1.da07c11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/adaptadorEsp01-1.svg
// module id = k/CV
// module chunks = 0